import logEvent from 'analytics/logEvent';
import React, { useEffect, useMemo } from 'react';

import Page from 'components/layouts/Page';
import Menu from 'components/pagesComponents/landing/Main/components/Menu';

import { useAppSelector } from 'redux-store';
import type { ILandingState } from 'redux-store/slices/landings/types';

import s from './template.module.scss';

export const TemplateDevice = (): React.ReactElement => {
  const page = 'Apple_Watch_HRV';
  const { userAgent } = useAppSelector(state => state.ui);
  const { data }: { data: ILandingState['data'] } = useAppSelector(
    state => state.landings,
  );
  const { appleOneLinkUrl, googleOneLinkUrl } = useAppSelector(
    state => state.experiments,
  );
  const isIOS = userAgent.os.name === 'iOS';
  const seo = useMemo(
    () => ({
      title: data?.title,
      description: data?.description,
      canonical: data?.Canonical,
    }),
    [data],
  );

  useEffect(() => {
    logEvent('page viewed', { page });
  }, []);

  return (
    <Page withoutHeader fullFooter fullWidth seo={seo} className={s.container}>
      <Menu hideTopBanner />
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/OwlCarousel2/2.3.4/assets/owl.carousel.min.css"
      />
      <link
        rel="stylesheet"
        href="/devices-static/css/styles.css?version=0.6.0"
      />
      <script
        src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.3.1/jquery.min.js"
        defer
      />
      <script
        src="https://cdnjs.cloudflare.com/ajax/libs/OwlCarousel2/2.3.4/owl.carousel.min.js"
        defer
      />
      <script src="/devices-static/js/script.js" defer />
      <section className="opener">
        <div className="wrapper flex">
          <div className="pic-box">
            <img
              src={data?.Top_Image_url}
              alt={data?.Top_Image_alt}
              title={data?.Top_Image_title}
            />
          </div>
          <div className="text-box">
            <h1 className="font-48-64">{data?.H1}</h1>
            <div className="undertext font-24-32">{data?.Text_1st}</div>
            <div className="buttons-box flex-end">
              <div className="buttons">
                <a
                  className="gp white-button font-20-32 margbottom"
                  rel="nofollow noreferrer"
                  title="Welltory Google Play"
                  target="_blank"
                  href={googleOneLinkUrl}
                  onClick={(): void => {
                    logEvent('Web_Commland_Store_Button_Clicked', {
                      page,
                      type: 'googleplay',
                    });
                  }}
                >
                  {/* eslint-disable-next-line react/jsx-max-depth */}
                  <span>Google Play</span>
                </a>
                <a
                  className="as white-button font-20-32"
                  rel="nofollow noreferrer"
                  title="Welltory App Store"
                  target="_blank"
                  href={appleOneLinkUrl}
                  onClick={(): void => {
                    logEvent('Web_Commland_Store_Button_Clicked', {
                      page,
                      type: 'appstore',
                    });
                  }}
                >
                  {/* eslint-disable-next-line react/jsx-max-depth */}
                  <span>App Store</span>
                </a>
              </div>
              <div className="qr">
                <div className="text font-12-16 flex-end">
                  Scan QR code
                  {/* eslint-disable-next-line react/jsx-max-depth */}
                  <br /> to get Welltory
                  {/* eslint-disable-next-line react/jsx-max-depth */}
                  <br /> app now
                </div>
              </div>
            </div>
          </div>
          <div className="buttons visible-only-under-1200">
            {isIOS ? (
              <a
                className="as white-button font-20-32"
                rel="nofollow noreferrer"
                title="Welltory App Store"
                target="_blank"
                href={appleOneLinkUrl}
                onClick={(): void => {
                  logEvent('Web_Commland_Store_Button_Clicked', {
                    page,
                    type: 'appstore',
                  });
                }}
              >
                <span>App Store</span>
              </a>
            ) : (
              <a
                className="gp white-button font-20-32"
                rel="nofollow noreferrer"
                title="Welltory Google Play"
                target="_blank"
                href={googleOneLinkUrl}
                onClick={(): void => {
                  logEvent('Web_Commland_Store_Button_Clicked', {
                    page,
                    type: 'googleplay',
                  });
                }}
              >
                <span>Google Play</span>
              </a>
            )}
          </div>
        </div>
      </section>
      <section className="advantages">
        <div className="wrapper">
          <h2 className="font-48-64">{data?.H2_benefits}</h2>
          <div className="row-box">
            <div className="row first flex">
              <div className="text">
                <div className="title font-24-32">{data?.Benefit1_Heading}</div>
                <div className="desc font-20-32">{data?.Benefit1_Text}</div>
              </div>
              <div className="img">
                <img
                  src={data?.Benefit1_Image_url}
                  alt={data?.Benefit1_Image_alt}
                />
              </div>
            </div>
            <div className="row second flex">
              <div className="text">
                <div className="title font-24-32">{data?.Benefit2_heading}</div>
                <div className="desc font-20-32">{data?.Benefit2_Text}</div>
              </div>
              <div className="img">
                <img
                  src={data?.Benefit2_Image_url}
                  alt={data?.Benefit2_Image_alt}
                />
              </div>
            </div>
            <div className="row third flex">
              <div className="text">
                <div className="title font-24-32">{data?.Benefit3_heading}</div>
                <div className="desc font-20-32">{data?.Benefit3_Text}</div>
              </div>
              <div className="img">
                <img
                  src={data?.Benefit3_Image_url}
                  alt={data?.Benefit3_Image_alt}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        className="appleconnect"
        style={{
          backgroundImage: `url(${data?.integration_Image_url as string})`,
        }}
      >
        <div className="wrapper">
          <div className="box">
            <div className="text">
              <h2
                className="font-48-64"
                dangerouslySetInnerHTML={{
                  __html: data?.H2_integrations as string,
                }}
              />
              <ol
                className="font-20-32"
                dangerouslySetInnerHTML={{
                  __html: data?.integration_Text as string,
                }}
              />
            </div>
          </div>
          <div className="subtext font-20-32">{data?.Personal_data_text}</div>
        </div>
      </section>
      <section className="rewievs">
        <div className="wrapper">
          <h2 className="font-48-64 center">{data?.H2_social}</h2>
          <div className="owl-rev-wrapper overhidden">
            <div className="owl-rev">
              <div className="item">
                <div className="rating">
                  {/* eslint-disable-next-line react/jsx-max-depth */}
                  <span className="full-star star" />
                  {/* eslint-disable-next-line react/jsx-max-depth */}
                  <span className="full-star star" />
                  {/* eslint-disable-next-line react/jsx-max-depth */}
                  <span className="full-star star" />
                  {/* eslint-disable-next-line react/jsx-max-depth */}
                  <span className="full-star star" />
                  {/* eslint-disable-next-line react/jsx-max-depth */}
                  <span className="full-star star" />
                </div>
                <div className="name font-20-32">Fentod</div>
                <div className="title font-20-32">Amazing App</div>
                <div className="text font-16-24">
                  This is the best app I’ve ever used for wellness both physical
                  and emotional. It encourages me to use the breathe app on my
                  Apple Watch more often and gives me a detailed analysis of my
                  HRV, making it easier for me to assess my general state of
                  readiness.
                </div>
              </div>
              <div className="item">
                <div className="rating">
                  {/* eslint-disable-next-line react/jsx-max-depth */}
                  <span className="full-star star" />
                  {/* eslint-disable-next-line react/jsx-max-depth */}
                  <span className="full-star star" />
                  {/* eslint-disable-next-line react/jsx-max-depth */}
                  <span className="full-star star" />
                  {/* eslint-disable-next-line react/jsx-max-depth */}
                  <span className="full-star star" />
                  {/* eslint-disable-next-line react/jsx-max-depth */}
                  <span className="full-star star" />
                </div>
                <div className="name font-20-32">Wakabiki</div>
                <div className="title font-20-32">Life Changing App</div>
                <div className="text font-16-24">
                  I came across Welltory at a very stressed time of life. It’s
                  empirical assessment, clear presentation and deep data and
                  descriptions have been exactly what I need to understand where
                  I am at physically and emotionally. I recommend this app for
                  everyone wanting to find better balance and control of their
                  life.
                </div>
              </div>
              <div className="item">
                <div className="rating">
                  {/* eslint-disable-next-line react/jsx-max-depth */}
                  <span className="full-star star" />
                  {/* eslint-disable-next-line react/jsx-max-depth */}
                  <span className="full-star star" />
                  {/* eslint-disable-next-line react/jsx-max-depth */}
                  <span className="full-star star" />
                  {/* eslint-disable-next-line react/jsx-max-depth */}
                  <span className="full-star star" />
                  {/* eslint-disable-next-line react/jsx-max-depth */}
                  <span className="full-star star" />
                </div>
                <div className="name font-20-32">Vbiohacker</div>
                <div className="title font-20-32">Great biofeedback app</div>
                <div className="text font-16-24">
                  Must say this is first review I’ve done due to the app truly
                  being one of the best all round apps I’ve used. Have my Oura
                  ring synced up, muse headband and fitness pal. Currently using
                  the polar chest strap for measurements and recovering from
                  several long term illnesses and chronic pain. It’s really
                  helped see what works and what doesn’t for my own body. Thanks
                  and keep up the great work
                </div>
              </div>
              <div className="item">
                <div className="rating">
                  {/* eslint-disable-next-line react/jsx-max-depth */}
                  <span className="full-star star" />
                  {/* eslint-disable-next-line react/jsx-max-depth */}
                  <span className="full-star star" />
                  {/* eslint-disable-next-line react/jsx-max-depth */}
                  <span className="full-star star" />
                  {/* eslint-disable-next-line react/jsx-max-depth */}
                  <span className="full-star star" />
                  {/* eslint-disable-next-line react/jsx-max-depth */}
                  <span className="full-star star" />
                </div>
                <div className="name font-20-32">Alexandru Taga</div>
                <div className="title font-20-32">Like it a lot</div>
                <div className="text font-16-24">
                  This is my first review for an IOS app, and this one made me
                  write it, because I really like the general appearance,
                  measurements seem to be close to reality, it is not invasive
                  with commercials. That is the free version. I have seen that
                  the premium has some more usefull in-depth details and options,
                  although for me it has a price a bit too high. It seems nicer
                  than the IOS health app. Very good job to developers.
                </div>
              </div>
              <div className="item">
                <div className="rating">
                  {/* eslint-disable-next-line react/jsx-max-depth */}
                  <span className="full-star star" />
                  {/* eslint-disable-next-line react/jsx-max-depth */}
                  <span className="full-star star" />
                  {/* eslint-disable-next-line react/jsx-max-depth */}
                  <span className="full-star star" />
                  {/* eslint-disable-next-line react/jsx-max-depth */}
                  <span className="full-star star" />
                  {/* eslint-disable-next-line react/jsx-max-depth */}
                  <span className="full-star star" />
                </div>
                <div className="name font-20-32">Xekc</div>
                <div className="title font-20-32">Know yourself</div>
                <div className="text font-16-24">
                  Best I could find for heart data feedback. I’ve got just one
                  body, so using it well, coming into a good balance with the
                  pressure of the world is important and I want to get better at
                  it, this app app helps.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="tryforfree">
        <div className="wrapper">
          <div
            className="outer-box"
            style={{
              backgroundImage: `url("${data?.Mid_CTA_Image_url as string}")`,
            }}
          >
            <div className="inner-box">
              <div className="text">
                <h2 className="font-48-64">{data?.H2_Mid_CTA}</h2>
                <div className="rating">
                  {/* eslint-disable-next-line react/jsx-max-depth */}
                  <span className="font-24-32 number">4.65</span>
                  <span className="stars">
                    {/* eslint-disable-next-line react/jsx-max-depth */}
                    <img
                      src="/devices-static/css/images/rating_4_and_half.svg"
                      alt="welltory app rating"
                      title="welltory app rating"
                    />
                  </span>
                </div>
                <div className="base font-16-24">
                  {data?.Mid_CTA_review_txt}
                </div>
                <div className="buttons flex b-url-links">
                  <a
                    href="https://app.welltory.com/payments/plans/main/?coupon=blog_new_25"
                    className="pay-button pay-button-first"
                  >
                    {/* eslint-disable-next-line react/jsx-max-depth */}
                    <div className="pay-button-name">LIMITED OFFER</div>
                    {/* eslint-disable-next-line react/jsx-max-depth */}
                    <div className="pay-button-discount">
                      25% off Welltory Premium
                    </div>
                  </a>
                </div>
                <div className="buttons flex b-url-links-mobile">
                  <a
                    href="https://app.welltory.com/payments/plans/main/?coupon=blog_new_25"
                    className="pay-button pay-button-first"
                  >
                    {/* eslint-disable-next-line react/jsx-max-depth */}
                    <div className="pay-button-name">LIMITED OFFER</div>
                    {/* eslint-disable-next-line react/jsx-max-depth */}
                    <div className="pay-button-discount">
                      25% off Welltory Premium
                    </div>
                  </a>
                </div>
              </div>
              <div className="qr">
                <div className="text font-12-16 flex-end">
                  Scan QR code
                  {/* eslint-disable-next-line react/jsx-max-depth */}
                  <br /> to get Welltory
                  {/* eslint-disable-next-line react/jsx-max-depth */}
                  <br /> app now
                </div>
              </div>
            </div>
            <div className="shine" />
          </div>
        </div>
      </section>
      <section className="about">
        <div className="wrapper">
          <h2 className="font-48-64">{data?.H2_SEOtext}</h2>
          <div className="text-box">
            <div className="text">
              <div className="ttl font-24-32">{data?.SEO_head_left}</div>
              <div className="grey font-20-32">{data?.SEO_text_left}</div>
            </div>
            <div className="text">
              <div className="ttl font-24-32">{data?.SEO_head_right}</div>
              <div className="grey font-20-32">{data?.SEO_text_right}</div>
            </div>
          </div>
        </div>
      </section>
      <section className="faq">
        <div className="wrapper flex">
          <div className="left block">
            <h2 className="font-48-64">{data?.H2_FAQ}</h2>
          </div>
          <div className="right faq-box block">
            <div className="q">
              <div className="question font-20-32">{data?.FAQ_q1}</div>
              <div className="answer font-16-24">{data?.FAQ_answer1}</div>
            </div>
            <div className="q">
              <div className="question font-20-32">{data?.FAQ_q2}</div>
              <div className="answer font-16-24">{data?.FAQ_answer2}</div>
            </div>
            <div className="q">
              <div className="question font-20-32">{data?.FAQ_q3}</div>
              <div className="answer font-16-24">{data?.FAQ_answer3}</div>
            </div>
            <div className="q">
              <div className="question font-20-32">{data?.FAQ_q4}</div>
              <div className="answer font-16-24">{data?.FAQ_answer4}</div>
            </div>
            <div className="q">
              <div className="question font-20-32">{data?.FAQ_q5}</div>
              <div className="answer font-16-24">{data?.FAQ_answer5}</div>
            </div>
          </div>
        </div>
      </section>
      <section className="try">
        <div className="wrapper center">
          <h2 className="font-48-64">{data?.footer_CTA_H2}</h2>
          <div className="undert font-16-24 hidden-under-1200">
            {data?.footer_CTA_text}
          </div>
          <div className="undert font-16-24 visible-only-under-1200">
            {data?.footer_CTA_text_mobile}
          </div>
          <img
            className="hidden-under-1200"
            src="/devices-static/css/images/qr_landings.svg"
            alt="Welltory QR-code"
            title="Welltory QR-code"
          />
          <div className="buttons visible-only-under-1200">
            {isIOS ? (
              <a
                className="as white-button font-20-32"
                rel="nofollow noreferrer"
                title="Welltory App Store"
                target="_blank"
                href={appleOneLinkUrl}
                onClick={(): void => {
                  logEvent('Web_Commland_Store_Button_Clicked', {
                    page,
                    type: 'appstore',
                  });
                }}
              >
                <span>App Store</span>
              </a>
            ) : (
              <a
                className="gp white-button font-20-32"
                rel="nofollow noreferrer"
                title="Welltory Google Play"
                target="_blank"
                href={googleOneLinkUrl}
                onClick={(): void => {
                  logEvent('Web_Commland_Store_Button_Clicked', {
                    page,
                    type: 'googleplay',
                  });
                }}
              >
                <span>Google Play</span>
              </a>
            )}
          </div>
        </div>
      </section>
    </Page>
  );
};
